import Template from 'backbone/story/templates/comments/inline_comment_button.js.hamlc'

export default class InlineCommentButtonView extends Backbone.View
  initialize: (options) ->
    @options = $.extend({top : 0, enabled : true}, options)

  render: ->
    this.setElement(Template(
      enabled: @options.enabled,
      top: @options.top,
      fetched: @options.fetched
    ))



// WEBPACK FOOTER //
// ./app/javascript/backbone/story/views/comments/inline_comment_button_view.js.coffee